import { Etikett } from './Bausteine'
import { partner } from '@/data/inhalte'

export default function Partner() {
  return (
    <section id="partner" className="bg-white py-20 sm:py-24">
      <div className="huelle">
        <Etikett>In Kooperation mit</Etikett>
        <ul className="mt-10 grid gap-4 sm:grid-cols-3 sm:gap-5">
          {partner.map(p => (
            <li key={p.name} className="flex h-28 items-center justify-center rounded-[24px] border border-linie px-8 sm:h-32">
              <img src={p.logo} alt={p.name} width={p.breite} height={p.hoehe} loading="lazy" className="max-h-14 w-auto max-w-full object-contain sm:max-h-16" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
